import React, { useState } from 'react';
import InputBase from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// Password field with a show/hide visibility toggle. Accepts the same props as a
// standard input (value, onChange, name, id, placeholder, className, etc.).
export default function PasswordInput({ className, ...inputProps }) {
  const [show, setShow] = useState(false);

  return (
    <InputBase
      {...inputProps}
      fullWidth
      className={className}
      type={show ? 'text' : 'password'}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label={show ? 'Hide password' : 'Show password'}
            onClick={() => setShow(!show)}
            edge="end"
            size="small"
          >
            {show ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
}
